export default "__VITE_ASSET__C_zzju2E__"